import Marquee from "react-fast-marquee";

const ITEMS = ["Master a new language", "Unlock the world", "Edvio Institute", "Mangalore"];
const SEP = "\u2726";

export default function EditorialMarquee() {
  return (
    <section className="py-16 lg:py-24 border-y border-white/10 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <Marquee speed={28} gradient={false}>
        {ITEMS.concat(ITEMS).map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-stroke text-[clamp(2.5rem,7vw,6rem)] uppercase tracking-tight whitespace-nowrap px-8">
              {t}
            </span>
            <span className="text-[#C44900] text-2xl lg:text-4xl">{SEP}</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
